<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage kiupIbkView"
  >
    <header-area />

    <div class="worksView topPosition" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              The paradigm shift of<br />
              corporate banking
            </div>
            <div class="workSlogan mobile">
              The paradigm<br />
              shift of<br />
              corporate banking
            </div>
            <div class="workTopDay">
              <p>IBK기업은행 기업 디지털 채널 혁신 사업</p>
              <ul>
                <li>PC Web / App</li>
                <li>2022.11.07</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://kiup.ibk.co.kr/" target="_blank" class="siteAddr"
                >https://kiup.ibk.co.kr</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulipinc.com/sns/kiupIbk"
                    title="기업 뱅킹의 새로운 패러다임"
                    hashtags="플립커뮤니케이션즈,IBK기업은행"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulipinc.com/sns/kiupIbk"
                    title="기업 뱅킹의 새로운 패러다임"
                    hashtags="플립커뮤니케이션즈,IBK기업은행"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt">
            <marquee-text :duration="15"
              >&nbsp;The paradigm shift of corporate banking&nbsp;</marquee-text
            >
          </span>
          <img class="web" src="@/assets/images/works_view/kiup_ibk/visual.jpg" alt="" />
          <img class="mobile" src="@/assets/images/works_view/kiup_ibk/visual_m.jpg" alt="" />
        </div>
      </div>

      <div class="contsBox">
        <div class="topInfo">
          최근 은행권에서 가장 경쟁이 활발한 영역인 기업뱅킹 서비스는 기업 고객을 대상으로 하는 만큼
          많은 정보량과 복잡한 업무 흐름에 대응할 수 있어야 합니다. 따라서 개인뱅킹과는 다른
          기업뱅킹의 특성에 맞춘 차별화된 방법론이 필요합니다. 이에 IBK기업은행은 디지털 전환을
          가속화하고, 고객 경험 혁신을 통해 기업뱅킹 분야에서 격차를 벌리기 위해 기업인터넷뱅킹과
          기업스마트뱅킹을 동시에 개편했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <section class="kiupCon concept">
          <div class="viewInner">
            <div
              class="smallTit"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <span class="line">Concept</span>
            </div>
            <div class="txtWrap">
              <div class="tit">혁신의 시작을 마련하는 데 중점을 두었습니다.</div>
              <p>
                기업뱅킹은 개인뱅킹보다 더 많은 서비스와 화면들로 구성됩니다. 새롭게 추가되는
                서비스만 해도 방대한 양을 차지하는 데다, 기업뱅킹의 특성을 검토하고 앞으로의 방향을
                잡아가는 일은 이제 시작 단계였습니다. 따라서 추후 계속해서 이어질 혁신의 기반을
                마련하는 데 중점을 두고 기존에 사용하던 화면의 레이아웃은 유지하되, 스타일을
                변경하는 방식으로 개선했습니다.
              </p>
            </div>
            <div
              class="imgWrap1"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="flxin">
                <div class="rndCenter">
                  <div class="round">
                    <figure>
                      <img
                        src="@/assets/images/works_view/kiup_ibk/ione_bank_logo.svg"
                        alt="i-ONE Bank 기업"
                        class="logo1"
                      />
                    </figure>
                  </div>
                  <div class="dimround bg1"></div>
                  <div class="dimround bg2"></div>
                  <div class="dimround bg3"></div>
                </div>
                <div class="rndLeft">
                  <div class="round">
                    기업뱅킹이 필요로 하는
                    <strong>신규서비스의 구축</strong>
                  </div>
                </div>
                <div class="rndRight">
                  <div class="round">
                    계속해서 이어질
                    <strong>혁신의 기반을 마련</strong>
                  </div>
                </div>
                <div class="dotline ln1"><span></span></div>
                <div class="dotline ln2"><span></span></div>
              </div>
            </div>
          </div>
        </section>

        <section class="kiupCon sector">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 01</span>
          </div>
          <div class="txtWrap">
            <div class="tit">
              <span class="mbr">고객 유형별로</span> 필요한 정보를 담은 맞춤 설계
            </div>
            <p>
              <span class="dbr"
                >대표이사, 소상공인, 재무담당자 등 로그인 시 사용자 유형에 따라 필요한 정보를
                제공합니다.</span
              >
              <span class="dbr"
                >주요 계좌 정보와 대기 중인 결재 정보를 빠르게 확인할 수 있으며,</span
              >
              결재 업무가 없는 실무자와 단독 사용자는 자주 쓰는 계좌 정보를 별도로 설정해 이용할 수
              있습니다.
            </p>
          </div>

          <div
            class="imgWrap2"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="topBox">
              <div class="item i1">
                <div>
                  <img src="@/assets/images/works_view/kiup_ibk/chart_01.png" alt="" />
                  <p>소상공인</p>
                </div>
              </div>
              <div class="item i2">
                <div>
                  <img src="@/assets/images/works_view/kiup_ibk/chart_02.png" alt="" />
                  <p>대표이사</p>
                </div>
              </div>
              <div class="item i3">
                <div>
                  <img src="@/assets/images/works_view/kiup_ibk/chart_03.png" alt="" />
                  <p>재무담당자</p>
                </div>
              </div>
            </div>
            <div class="btmBox">
              <div class="itemInner">
                <div class="item i1">
                  <img
                    src="@/assets/images/works_view/kiup_ibk/pointA_item1.png"
                    alt="결재정보 15건"
                  />
                </div>
                <div class="item i2">
                  <img
                    src="@/assets/images/works_view/kiup_ibk/pointA_item2.png"
                    alt="개인계좌"
                    class="imgDesk"
                  />
                  <img
                    src="@/assets/images/works_view/kiup_ibk/pointA_item2_mob.png"
                    alt="개인계좌"
                    class="imgMobile"
                  />
                </div>
                <div class="item i3">
                  <img src="@/assets/images/works_view/kiup_ibk/pointA_item3.png" alt="기업계좌" />
                </div>
                <div class="item i4">
                  <img
                    src="@/assets/images/works_view/kiup_ibk/pointA_item4.png"
                    alt="총 매출현황"
                  />
                </div>
                <div class="item i5">
                  <img
                    src="@/assets/images/works_view/kiup_ibk/pointA_item5.png"
                    alt="총 매입현황"
                    class="imgDesk"
                  />
                  <img
                    src="@/assets/images/works_view/kiup_ibk/pointA_item5_mob.png"
                    alt="총 매입현황"
                    class="imgMobile"
                  />
                </div>
                <div class="item icoin">
                  <img src="@/assets/images/works_view/kiup_ibk/pointA_item_coin.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="kiupCon sector point2">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 02</span>
          </div>
          <div class="txtWrap">
            <div class="tit">
              <span class="mbr">모든 자산 현황을 한눈에 보는</span> 기업자산관리 서비스
            </div>
            <p>
              <span class="dbr"
                >메인 화면에서 전 은행 자산현황, 카드사별 매출매입 내역, 세금계산서 및 현금영수증
                정보 등을 빠르게 조회할 수 있는</span
              >
              <span class="dbr"
                >기업자산관리 서비스를 신설했습니다. 기업 자산의 흐름을 한눈에 파악할 수 있도록 월별
                집계를 함께 제공합니다.</span
              >
              대표이사의 경우, 인증을 거쳐 당행 개인 계좌 내역까지 편리하게 조회할 수 있습니다.
            </p>
          </div>

          <div
            class="imgWrap3"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="serviceWrap">
              <div
                class="serviceSlider swiper-container"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="grItem service1">
                      <div class="moblieBg">
                        <img src="@/assets/images/works_view/kiup_ibk/pointB_gr1_1.png" alt="" />
                      </div>
                      <div class="bubble">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_gr1_2.png"
                          alt="기업자산관린 서비스"
                        />
                      </div>
                      <div class="itemBc1">
                        <img src="@/assets/images/works_view/kiup_ibk/pointB_gr1_6.png" alt="" />
                      </div>
                      <div class="itemFr1">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_gr1_3.png"
                          alt="카드매출정산"
                        />
                      </div>
                      <div class="itemBc2">
                        <img src="@/assets/images/works_view/kiup_ibk/pointB_gr1_5.png" alt="" />
                      </div>
                      <div class="itemFr2">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_gr1_4.png"
                          alt="매입현황"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="swiper-slide">
                    <div class="grItem service2">
                      <div class="moblieBg">
                        <img src="@/assets/images/works_view/kiup_ibk/pointB_gr2_1.png" alt="" />
                      </div>
                      <div class="bubble">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_gr2_2.png"
                          alt="전 은행 자산현황 제공"
                        />
                      </div>
                      <div class="inRound i1"></div>
                      <div class="inRound i2"></div>
                      <div class="roundLine"></div>
                      <div class="bank bk1">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank1.svg"
                          alt="KB국민은행"
                        />
                      </div>
                      <div class="bank bk2">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank2.svg"
                          alt="카카오뱅크"
                        />
                      </div>
                      <div class="bank bk3">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank3.svg"
                          alt="토스뱅크"
                        />
                      </div>
                      <div class="bank bk4">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank4.svg"
                          alt="NH농협은행"
                        />
                      </div>
                      <div class="bank bk5">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank5.svg"
                          alt="한국씨티은행"
                        />
                      </div>
                      <div class="bank bk6">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank6.svg"
                          alt="하나은행"
                        />
                      </div>
                      <div class="bank bk7">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank7.svg"
                          alt="우리은행"
                        />
                      </div>
                      <div class="bank bk8">
                        <img
                          src="@/assets/images/works_view/kiup_ibk/pointB_bank8.svg"
                          alt="경남은행"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="menulist"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <img
                src="@/assets/images/works_view/kiup_ibk/pointB_gr1_menulist.png"
                alt="전 은행 계좌조회, 카드매출조회, 카드지출조회, 세금계산서조회, 현금영수증조회, 자산 월별 집계"
                class="imgDesk"
              />
              <img
                src="@/assets/images/works_view/kiup_ibk/pointB_gr1_menulist_mob.png"
                alt="전 은행 계좌조회, 카드매출조회, 카드지출조회, 세금계산서조회, 현금영수증조회, 자산 월별 집계"
                class="imgMobile"
              />
            </div>
          </div>
        </section>

        <section class="kiupCon sector point3">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 03</span>
          </div>
          <div class="txtWrap">
            <div class="tit">
              <span class="mbr">중요한 안내를 모아서</span> 알려 주는 통합 알림 서비스
            </div>
            <p>
              <span class="dbr"
                >입출금 알림, 금융업무 알림 등 여기저기 흩어져 있던 각종 알림 정보를
                통합했습니다.</span
              >
              <span class="dbr"
                >영업점 창구에서 신청한 상품 가입이나 상담 진행 과정, 서비스 이용과 관련한</span
              >
              주요 고지 사항도 통합 알림으로 함께 받아볼 수 있습니다.
            </p>
          </div>

          <div
            class="imgWrap4"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="bgInner">
              <div class="moblieBg">
                <img src="@/assets/images/works_view/kiup_ibk/pointC_phone.png" alt="" />
              </div>
              <div class="displayAlram">
                <img
                  src="@/assets/images/works_view/kiup_ibk/pointC_alram.png"
                  alt="새로운 알림이 도착했어요!"
                />
              </div>
              <div class="alram1">
                <img src="@/assets/images/works_view/kiup_ibk/pointC_mark1.png" alt="" />
              </div>
              <div class="alram2">
                <img src="@/assets/images/works_view/kiup_ibk/pointC_mark2.png" alt="" />
              </div>
              <div class="alram3">
                <img src="@/assets/images/works_view/kiup_ibk/pointC_mark3.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section class="kiupCon sector point4">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 04</span>
          </div>
          <div class="txtWrap">
            <div class="tit">
              <span class="mbr">영업점 방문 없이 빠르게!</span> 비대면 업무 확대
            </div>
            <p>
              <span class="dbr"
                >개인사업자 비대면 대출 신규/연장, 개인사업자 카드 발급, 법인카드 추가 발급과
                같이</span
              >
              <span class="dbr"
                >오프라인에서만 이용할 수 있었던 서비스를 디지털 채널에 도입해 업무 영역을
                확대했습니다.</span
              >
              <span class="dbr"
                >입력할 항목이 많아 복잡하고 불편했던 외화 송금은 간편하게 개선됐으며,</span
              >
              외국환거래 약정 등의 업무도 영업점 방문 없이 비대면으로 처리할 수 있습니다.<br />
              이후로도 신규 기능 추가 작업은 계속될 예정이며,이를 통해 고객 편의 개선과 영업점 업무
              경감을 추진할 계획입니다.
            </p>
          </div>

          <div class="roundBlur1"></div>
          <div class="roundBlur2"></div>
          <div class="roundBlur3"></div>

          <div class="imgWrap5">
            <div class="pointInner">
              <div
                class="itemRndtop"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="round1">
                  <div class="hand">
                    <img src="@/assets/images/works_view/kiup_ibk/pointD_hand.png" alt="" />
                  </div>
                  <div class="coin1">
                    <img src="@/assets/images/works_view/kiup_ibk/pointD_coin1.png" alt="" />
                  </div>
                  <div class="coin2">
                    <img src="@/assets/images/works_view/kiup_ibk/pointD_coin2.png" alt="" />
                  </div>
                  <div class="coin3">
                    <img src="@/assets/images/works_view/kiup_ibk/pointD_coin3.png" alt="" />
                  </div>
                </div>
                <div class="textBox">
                  <div class="arrow"></div>
                  <h5>
                    법인사업자
                    <strong>비대면 계좌개설</strong>
                  </h5>
                  <p>
                    은행 방문 없이 개인/법인 사업자<br />
                    365일 24시간 비대면 계좌 개설
                  </p>
                </div>
              </div>

              <div
                class="itemRndBtm"
                v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
              >
                <div class="round2">
                  <div class="card">
                    <img src="@/assets/images/works_view/kiup_ibk/pointD_card.png" alt="" />
                  </div>
                  <div class="coin">
                    <img src="@/assets/images/works_view/kiup_ibk/pointD_cardCoin.png" alt="" />
                  </div>
                </div>
                <div class="textBox">
                  <div class="arrow"></div>
                  <h5>
                    법인사업자
                    <strong>비대면 카드발급</strong>
                  </h5>
                  <p>
                    영업점을 방문해야 했던 법인카드 발급을<br />
                    인터넷뱅킹에서도 편리하게<br />
                    신청할 수 있도록 비대면 서비스 확장
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="kiupCon sector point5">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 05</span>
          </div>
          <div class="txtWrap">
            <div class="tit"><span class="mbr">기업 업무 특징에 맞는</span> 관리 서비스</div>
            <p>
              <span class="dbr"
                >관리자와 이용자로 나누어진 다단계 결재 서비스를 도입하고, 대직자 설정 및 결재 방식
                다양화를 통해</span
              >
              <span class="dbr"
                >복잡하게 얽힌 결재 프로세스를 간편하게 개선했습니다. 이와 함께 야간/주말 등 상황에
                따른</span
              >
              이용 시간 제어 서비스를 도입해 자금을 더욱 안전하게 통제할 수 있습니다.
            </p>
          </div>

          <div
            class="imgWrap6"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="pointBg"></div>
            <div class="pointScreen">
              <img src="@/assets/images/works_view/kiup_ibk/pointE_screen.png" alt="" />
            </div>
            <div class="pointAlram">
              <img src="@/assets/images/works_view/kiup_ibk/pointE_alram.png" alt="" />
            </div>
            <div class="pointPhone">
              <img src="@/assets/images/works_view/kiup_ibk/pointE_phone.png" alt="" />
            </div>
            <div class="pointSwitch">
              <img src="@/assets/images/works_view/kiup_ibk/pointE_switch.png" alt="" />
            </div>
          </div>
        </section>

        <section class="kiupCon sector point6">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 06</span>
          </div>
          <div class="txtWrap">
            <div class="tit"><span class="mbr">로그인 한 번으로 이용하는</span> 외부 서비스</div>
            <p>
              <span class="dbr"
                >뱅킹 외부에 별도로 존재했던 IBK기업은행의 경영 지원 서비스를 내부로 이전해 뱅킹
                로그인 한 번으로</span
              >
              <span class="dbr"
                >외부 서비스까지 이용할 수 있게 개선했습니다. 또한, 기존 서비스 외에 법인 대상의
                주주 명부 서비스와</span
              >
              개인 사업자 대상의 사업 분석, 상권 분석, 배달앱 매출 조회 등의 경영 지원 서비스가 새로
              추가됐습니다.
            </p>
          </div>

          <div class="imgWrap7">
            <ul
              class="serviceList"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <li>
                <img
                  src="@/assets/images/works_view/kiup_ibk/pointF_item1.png"
                  alt="ZUZU서비스 - 창업부터 상장까지 중소기업 전용 주주관리 서비스"
                />
              </li>
              <li>
                <img
                  src="@/assets/images/works_view/kiup_ibk/pointF_item2.png"
                  alt="중소기업 디지털서비스 바우처 - IBK주관 중소기업 디지털 전환에 꼭 필요한 서비스를 1년가 무료로 이용해보세요!"
                />
              </li>
              <li>
                <img
                  src="@/assets/images/works_view/kiup_ibk/pointF_item3.png"
                  alt="IBK sERP 경리나라 - 거래처관리, 매출/매입, 스마트보고서까지 지금 바로 이용해 보세요"
                />
              </li>
            </ul>
          </div>
        </section>

        <section class="kiupCon sector point7">
          <div
            class="smallTit"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <span class="line">Point 07</span>
          </div>
          <div class="txtWrap">
            <div class="tit"><span class="mbr">자주 쓰는 업무 중심으로</span> 메뉴 개편</div>
            <p>
              <span class="dbr"
                >기업 고객 대상의 상품과 서비스를 모두 나열한 메뉴를 고객이 주로 이용하는 업무
                중심으로 재편했습니다.</span
              >
              <span class="dbr"
                >최근 이용한 메뉴를 눈에 띄게 배치하고, 즐겨 찾는 메뉴를 쉽게 등록하고 이용할 수
                있게 재구성했습니다.</span
              >
              또한, 큰 변화로 인한 혼란을 방지하고자 기존의 메뉴명과 구조를 그대로 이용한 검색
              서비스를 함께 제공합니다.
            </p>
          </div>

          <div
            class="imgWrap8"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="pointInner">
              <div class="pointScreen2">
                <img src="@/assets/images/works_view/kiup_ibk/pointG_screen.png" alt="" />
              </div>
              <div class="pointAlram2">
                <img src="@/assets/images/works_view/kiup_ibk/pointG_alram.png" alt="" />
              </div>
              <div class="pointBubble2">
                <img src="@/assets/images/works_view/kiup_ibk/pointG_bubble.png" alt="" />
              </div>
              <div class="pointLayer2">
                <img src="@/assets/images/works_view/kiup_ibk/pointG_layer.png" alt="" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-kyobo' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">교보생명 모바일 통합 구축</strong>
          <strong class="mobile">교보생명<br />모바일 통합 구축</strong>
        </div>

        <div class="engBg kyoboEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import { TweenLite } from "gsap/all";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: 'IBK기업은행 기업 디지털 채널 혁신 사업'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      W: 0,
      icoInter: null,
      icoVal: 0,
      meta: {
        siteName: "IBK기업은행 기업뱅킹 | 플립커뮤니케이션즈",
        title: "IBK기업은행 기업뱅킹",
        desc:
          "IBK기업은행은 기업인터넷뱅킹과 기업스마트뱅킹을 동시에 개편하여 기업 고객의 디지털 이용 편의성을 대폭 향상시켰습니다. 대표이사, 소상공인, 재무담당자 등 사용자 유형별 맞춤형 서비스, 기업자산 통합관리 서비스 등을 신규로 도입하고 결재, 외화송금 등의 서비스를 개선하여 기업 뱅킹 경쟁력을 높였습니다.",
        keywords:
          "기업뱅킹, IBK기업은행, 디지털 채널, 혁신, 기업인터넷뱅킹, 기업스마트뱅킹, 기업자산관리, 자산 현황, 알림 서비스, 비대면 업무, 결재 서비스, 외부 서비스, 경영 지원 서비스, 중소기업 전용, 업무 중심 메뉴",
        url: "https://www.pulip.com/works/KiupIBK",
        img: "https://www.pulip.com/pulip-logo.jpg"
      }
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulipinc.com/sns/samsungLife").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.serviSlider.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.serviSlider = new window.Swiper(".serviceSlider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      effect: "fade",
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 200,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    });
  }
};
</script>
